<div class="bg"></div>

<div class="content">
  <img src="assets/images/logo_txt_sphere_big.png" class="logo-auth" alt="logo" />
  <router-outlet></router-outlet>
</div>
